<template>
  <div class="admin-payments">
    <header-title title="Historial de Logs"></header-title>

    <br />
    <v-row>
      <v-col cols="12" sm="6" md="3" class="py-0 py-sm-1">
        <date-picker-range @updateDates="updateDates"></date-picker-range>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" sm="6" md="3">
        <v-text-field
          label="Buscar"
          v-model="search"
          class="select-box"
          prepend-inner-icon="mdi-magnify"
          outlined
          dense
        />
      </v-col>
      <v-col cols="12" sm="6" md="3">
        <v-select
          v-model="levelSelected"
          :items="levels"
          item-text="level"
          item-value="level"
          label="Tipo de log"
          class="select-box"
          dense
          outlined
        ></v-select>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-data-table
          :headers="headers"
          :items="filteredLogs"
          class="elevation-1 payments-table"
          :search="search"
          :footer-props="{
            'items-per-page-options': [50, 100, 150, -1]
          }"
          :items-per-page="50"
        >
          <template v-slot:[`item.time`]="{ item }">
            <div style="display: flex">
              <div>
                {{ formatDate(item.time) + " " + formatTime(item.time) }}
              </div>
            </div>
          </template>
          <template v-slot:[`item.level`]="{ item }">
            <div style="display: flex">
              <div>
                <span v-if="item.level === 'ERROR'" style="color: red">
                  {{ item.level }}
                </span>
                <span
                  v-if="item.level === 'INFO'"
                  style="color: cornflowerblue"
                >
                  {{ item.level }}
                </span>
              </div>
            </div>
          </template>
          <template v-slot:[`item.data`]="{ item }">
            <div style="display: flex">
              <v-dialog transition="dialog-bottom-transition" max-width="600">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn color="primary" v-bind="attrs" v-on="on">View</v-btn>
                </template>
                <template v-slot:default="dialog">
                  <v-card>
                    <v-toolbar color="primary" dark>Data</v-toolbar>
                    <v-card-text>
                      <div class="pa-12">
                        {{ JSON.stringify(item.data, null, 2) }}
                      </div>
                    </v-card-text>
                    <v-card-actions class="justify-end">
                      <v-btn text @click="dialog.value = false">Close</v-btn>
                    </v-card-actions>
                  </v-card>
                </template>
              </v-dialog>
            </div>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import moment from "moment";
import { getLogsByDateRange } from "@/collections/logs";
import { LogsHistoryTableHeader } from "@/utils/tableHeaderconstants.js";
import DatePickerRange from "@/components/common/DatePickerRange";
import HeaderTitle from "@/components/admin/common/HeaderTitle";

export default {
  name: "Logs-History",
  components: { DatePickerRange, HeaderTitle },
  data() {
    return {
      logsCollection: [],
      search: "",
      levels: [{ level: "TODOS" }, { level: "ERROR" }, { level: "INFO" }],
      levelSelected: "",
      headers: [...LogsHistoryTableHeader]
    };
  },
  computed: {
    filteredLogs() {
      let _logs = [...this.logsCollection];

      if (this.levelSelected !== "" && this.levelSelected !== "TODOS") {
        _logs = _logs.filter(log => {
          return log.level.toLowerCase() === this.levelSelected.toLowerCase();
        });
      }

      return _logs;
    }
  },
  methods: {
    updateDates(dates) {
      if (dates.length === 1 || dates[0] === dates[1]) {
        this.updateOneDate(dates);
        return;
      }

      if (dates.length === 2) {
        this.updateTwoDates(dates);
      }
    },
    async updateOneDate(dates) {
      let date1 = moment(dates[0])
        .startOf("day")
        .toDate();
      let date2 = moment(dates[0])
        .endOf("day")
        .toDate();

      try {
        this.logsCollection = await getLogsByDateRange(date1, date2);
      } catch (error) {
        this.setlogError(
          "get_logs",
          "Error getting documents",
          error.stack,
          this.$options.name
        );
      }
    },
    async updateTwoDates(dates) {
      let date1 = moment(dates[0])
        .startOf("day")
        .toDate();
      let date2 = moment(dates[1])
        .endOf("day")
        .toDate();

      try {
        this.logsCollection = await getLogsByDateRange(date1, date2);
      } catch (error) {
        this.setlogError(
          "get_logs",
          "Error getting documents",
          error.stack,
          this.$options.name
        );
      }
    }
  }
};
</script>

<style scoped></style>
